<template>
    <div class="the-header">
        <div class="left">
            <div class="left-logo-1">
                <router-link :to="{name: 'big-screen-map'}" v-if="userType=='partner'">
                    <div class="icon"></div>
                </router-link>
                <div class="icon" v-else></div>
            </div>
            <div class="left-logo-2">
                <div class="icon"></div>
            </div>
            <span class="left-title">运维云</span>
        </div>
        <div class="center">{{$store.state.main.title}}</div>
        <div class="right">
            <el-tooltip class="item" effect="dark" content="返回" placement="bottom" transition="none" v-if="$store.state.main.back">
                <el-button type="primary" size="" circle icon="el-icon-back" @click="$router.back(-1)"></el-button>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    const log = new Log("Components/the-header")
    export default {
        name: "the-header",
        data() {
            return {
            }
        },
        computed: {
            userType(){
                return window.sessionStorage.userType;
            },
        },
        methods: {},
    }
</script>

<style lang="less">
    @import url("../style/color.less");
    .the-header {
        width: 100%;
        height: 60px;
        background-color: @Color-Primary;
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        .left {
            width: auto;
            height: 100%;
            padding-right: 15px;
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            align-items: center;
            z-index: 101;
            cursor: default;
            .left-logo-1 {
                width: 60px;
                height: 60px;
                padding: 15px;
                margin-right: 10px;
                .icon {
                    width: 100%;
                    height: 100%;
                    background-size: cover;
                    background-image: url("/img/logo_1.png");
                }
            }
            // .left-logo-2 {
            //     width: 240+30px;
            //     height: 100%;
            //     padding: 15px;
            //     .icon {
            //         width: 100%;
            //         height: 100%;
            //         background-size: cover;
            //         background-image: url("/img/login-logo-white.svg");
            //     }
            // }
            .left-title {
                font-weight: 100;
                color: #fff;
                font-size: 20px;
            }
        }
        .center {
            height: 100%;
            color: #fff;
            font-size: 18px;
        }
        .right {
            height: 100%;
            position: absolute;
            right: 0;
            top: 0;
            padding: 0 10px;
            button {
                height: 40px;
                i {
                    font-weight: 600;
                }
            }
        }
    }

    .map-enter-active {
        transition: all .5s ease;
    }
    .map-leave-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .map-enter, .map-leave-to {
        transform: scale(2);
        opacity: 0;
    }
</style>